import React, { useState } from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { leagueEventStore } from 'state/league/leagueEvent'
import { WeekDays } from 'types/globalTypes'
import { Checkbox } from 'antd'
import { infoMessage } from 'api/global'
import { getDayNamesBetweenDates, convertToLocal } from 'helper/utility'

interface TimeCopyProps {
  day: WeekDays
}

const TimeCopy: React.FC<TimeCopyProps> = ({ day }) => {
  const {
    copyTimeModal,
    setCopyTimeModal,
    timeSlots,
    setTimeSlots,
    leagueData,
  } = leagueEventStore(store => ({
    copyTimeModal: store.copyTimeModal,
    setCopyTimeModal: store.setCopyTimeModal,
    timeSlots: store.timeSlots,
    setTimeSlots: store.setTimeSlots,
    leagueData: store.leagueData,
  }))
  const [checkedDays, setCheckedDays] = useState<WeekDays[]>([])

  const handleSubmit = () => {
    if (!checkedDays.length)
      return infoMessage('Please select at least one day')
    const dayKey = day.toLowerCase()

    if (!timeSlots || !timeSlots[dayKey] || timeSlots[dayKey].length === 0) {
      setCopyTimeModal(false)
      return infoMessage(`First add some time to ${day}`)
    }

    const updatedTimeSlots = { ...timeSlots }
    checkedDays.forEach((day: WeekDays) => {
      const selectedDay = day.toLowerCase()
      updatedTimeSlots[selectedDay] = timeSlots[dayKey]
    })

    setTimeSlots(updatedTimeSlots)
    setCopyTimeModal(false)
  }

  const handleCheckboxChange = (day: WeekDays, isChecked: boolean) => {
    if (isChecked) {
      setCheckedDays(prev => [...prev, day])
    } else {
      setCheckedDays(prev => prev.filter(item => item !== day))
    }
  }

  // Get the event days based on start and end dates
  const eventDays = leagueData?.datesOfEvent
    ? (getDayNamesBetweenDates(
        convertToLocal(leagueData.datesOfEvent[0]),
        convertToLocal(
          leagueData.datesOfEvent[leagueData.datesOfEvent.length - 1],
        ),
      ) as WeekDays[])
    : []

  return (
    <>
      <CustomModal
        title="Enter time"
        openModal={copyTimeModal}
        closeModal={setCopyTimeModal}
        footer={
          <CustomModalFooter
            btnAlignment="justify-end"
            btnText="Save"
            multibutton={false}
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <div>
          {eventDays
            .filter(eventDay => eventDay !== day)
            .map((eventDay: WeekDays, index: number) => {
              return (
                <div
                  className="mt-15px flex align-center justify-between gap-20px pr-10px"
                  key={index}
                >
                  <p className="text-15 w-500">{eventDay}</p>
                  <Checkbox
                    onChange={e =>
                      handleCheckboxChange(eventDay, e.target.checked)
                    }
                  />
                </div>
              )
            })}
        </div>
      </CustomModal>
    </>
  )
}

export default TimeCopy
